import { MdVerified, MdStar, MdAccessTime, MdPayment } from 'react-icons/md';
import { t } from '../../utils/i18n';

const BADGES = [
  { key: 'verified', icon: MdVerified },
  { key: 'reviews', icon: MdStar },
  { key: 'tracking', icon: MdAccessTime },
  { key: 'payment', icon: MdPayment },
];

export default function TrustBadges() {
  return (
    <ul className="landing-trust-strip flex flex-wrap gap-x-5 gap-y-2.5 list-none p-0 m-0">
      {BADGES.map(({ key, icon: Icon }) => (
        <li key={key} className="inline-flex items-center gap-2 text-sm text-[var(--color-text-muted)]">
          <Icon className="text-[17px] flex-shrink-0 opacity-55" aria-hidden="true" />
          <span>{t(`landing.trust.${key}`)}</span>
        </li>
      ))}
    </ul>
  );
}
